import { render } from "./TheHeader.vue?vue&type=template&id=70a9f370&ts=true"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"

import "./TheHeader.vue?vue&type=style&index=0&id=70a9f370&lang=css"

import exportComponent from "/Users/mufeng/Documents/ProjectWorkbench/hotaru_theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__